import React, { useState } from "react";
import { Drawer, Box, TextField, Typography, Button } from "@mui/material";
import closeimg from "../../assets/img/Close.jpg";
import { useTranslation } from "react-i18next";

const FilterRightBox = ({ open, onClose, onApplyFilters }) => {
  const { t } = useTranslation();
  const [filters, setFilters] = useState({
    Name: "",
    Version: "",
    Type: "",
    Creator: "",
    lastUpdate: { from: "", to: "" },
  });

  // Manejador para los inputs de texto
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  // Manejador para los inputs de fecha (lastUpdate)
  const handleLastUpdateChange = (e) => {
    const { name, value } = e.target; // name es "from" o "to"
    setFilters((prev) => ({
      ...prev,
      lastUpdate: { ...prev.lastUpdate, [name]: value },
    }));
  };

  // Al aplicar se pasa el objeto de filtros al callback del padre
  const handleApply = () => {
    if (onApplyFilters) {
      onApplyFilters(filters);
    }
    if (onClose) {
      onClose();
    }
  };

  const handleClear = () => {
    setFilters({
      Name: "",
      Version: "",
      Type: "",
      Creator: "",
      lastUpdate: { from: "", to: "" },
    });
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      ModalProps={{
        BackdropProps: {
          sx: {
            backgroundColor: "transparent",
          },
        },
      }}
      PaperProps={{
        sx: {
          width: "428px",
          height: "calc(100vh - 80px)",
          top: "80px",
          position: "absolute",
          zIndex: 1300,
        },
      }}
      transitionDuration={{ enter: 300, exit: 300 }}
    >
      <Box
        p={4}
        display="flex"
        flexDirection="column"
        height="100%"
        justifyContent="space-between"
      >
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <h2 style={{ margin: 0, fontWeight: "lighter" }}>
            {t("filters.filters")}
          </h2>
          <Button
            onClick={onClose}
            aria-label="Close filters"
            sx={{ minWidth: "auto", p: 0, lineHeight: 0 }}
          >
            <img src={closeimg} alt="" />
          </Button>
        </Box>

        <Box mt={2} flexGrow={1}>
          <Typography
            sx={{
              color: "black",
              whiteSpace: "nowrap",
            }}
          >
            {t("filters.dataModel.name")}
          </Typography>
          <TextField
            fullWidth
            variant="outlined"
            name="Name"
            placeholder={t("filters.placeholder.name")}
            value={filters.Name}
            onChange={handleChange}
            sx={{
              marginTop: 0,
              marginBottom: "2%",
              borderRadius: "6px",

              "& .MuiOutlinedInput-root": {
                // Estado normal (sin hover/focus)
                "& fieldset": {
                  borderColor: "#2E404D",
                },
                // Estado hover
                "&:hover fieldset": {
                  borderColor: "rgba(0,91,176,0.75)",
                  boxShadow: "1px 0px 3px 0px rgba(0,91,176,0.75)",
                  webkitBoxShadow: "1px 0px 3px 0px rgba(0,91,176,0.75)",
                  mozBoxShadow: "1px 0px 3px 0px rgba(0,91,176,0.75)",
                },
                // Estado focus (clic activo)
                "&.Mui-focused fieldset": {
                  boxShadow: "0px 0px 0px 0px rgba(0,91,176,0.75)",
                  webkitBoxShadow: "0px 0px 0px 0px rgba(0,91,176,0.75)",
                  mozBoxShadow: "0px 0px 0px 0px rgba(0,91,176,0.75)",
                  borderColor: "#1976d2",
                },
              },

              "& .MuiOutlinedInput-input": {
                padding: "6px 12px",
                "&::placeholder": {
                  color: "#2E404D",
                },
              },
            }}
          />
          <Typography
            sx={{
              color: "black",
              whiteSpace: "nowrap",
              marginTop: "4%",
            }}
          >
            {t("filters.dataModel.version")}
          </Typography>
          <TextField
            fullWidth
            placeholder={t("filters.placeholder.version")}
            name="Version"
            value={filters.Version}
            onChange={handleChange}
            variant="outlined"
            sx={{
              marginTop: 0,
              marginBottom: "2%",
              borderRadius: "6px",

              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#2E404D",
                },
                "&:hover fieldset": {
                  borderColor: "rgba(0,91,176,0.75)",
                  boxShadow: "1px 0px 3px 0px rgba(0,91,176,0.75)",
                  webkitBoxShadow: "1px 0px 3px 0px rgba(0,91,176,0.75)",
                  mozBoxShadow: "1px 0px 3px 0px rgba(0,91,176,0.75)",
                },
                "&.Mui-focused fieldset": {
                  boxShadow: "0px 0px 0px 0px rgba(0,91,176,0.75)",
                  webkitBoxShadow: "0px 0px 0px 0px rgba(0,91,176,0.75)",
                  mozBoxShadow: "0px 0px 0px 0px rgba(0,91,176,0.75)",
                  borderColor: "#1976d2",
                },
              },

              "& .MuiOutlinedInput-input": {
                padding: "6px 12px",
                "&::placeholder": {
                  color: "#2E404D",
                },
              },
            }}
          />
          <Typography
            sx={{
              color: "black",
              whiteSpace: "nowrap",
              marginTop: "4%",
            }}
          >
            {t("filters.dataModel.format")}
          </Typography>
          <TextField
            fullWidth
            placeholder={t("filters.placeholder.format")}
            name="Format"
            value={filters.Type}
            onChange={handleChange}
            variant="outlined"
            sx={{
              marginTop: 0,
              marginBottom: "2%",
              borderRadius: "6px",

              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#2E404D",
                },
                "&:hover fieldset": {
                  borderColor: "rgba(0,91,176,0.75)",
                  boxShadow: "1px 0px 3px 0px rgba(0,91,176,0.75)",
                  webkitBoxShadow: "1px 0px 3px 0px rgba(0,91,176,0.75)",
                  mozBoxShadow: "1px 0px 3px 0px rgba(0,91,176,0.75)",
                },
                "&.Mui-focused fieldset": {
                  boxShadow: "0px 0px 0px 0px rgba(0,91,176,0.75)",
                  webkitBoxShadow: "0px 0px 0px 0px rgba(0,91,176,0.75)",
                  mozBoxShadow: "0px 0px 0px 0px rgba(0,91,176,0.75)",
                  borderColor: "#1976d2",
                },
              },

              "& .MuiOutlinedInput-input": {
                padding: "6px 12px",
                "&::placeholder": {
                  color: "#2E404D",
                },
              },
            }}
          />
          <Typography
            sx={{
              color: "black",
              whiteSpace: "nowrap",
              marginTop: "4%",
            }}
          >
            {t("filters.dataModel.creator")}
          </Typography>
          <TextField
            fullWidth
            placeholder={t("filters.placeholder.creator")}
            name="Creator"
            value={filters.Creator}
            onChange={handleChange}
            variant="outlined"
            sx={{
              marginTop: 0,
              marginBottom: "2%",
              borderRadius: "6px",

              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#2E404D",
                },
                "&:hover fieldset": {
                  borderColor: "rgba(0,91,176,0.75)",
                  boxShadow: "1px 0px 3px 0px rgba(0,91,176,0.75)",
                  webkitBoxShadow: "1px 0px 3px 0px rgba(0,91,176,0.75)",
                  mozBoxShadow: "1px 0px 3px 0px rgba(0,91,176,0.75)",
                },
                "&.Mui-focused fieldset": {
                  boxShadow: "0px 0px 0px 0px rgba(0,91,176,0.75)",
                  webkitBoxShadow: "0px 0px 0px 0px rgba(0,91,176,0.75)",
                  mozBoxShadow: "0px 0px 0px 0px rgba(0,91,176,0.75)",
                  borderColor: "#1976d2",
                },
              },

              "& .MuiOutlinedInput-input": {
                padding: "6px 12px",
                "&::placeholder": {
                  color: "#2E404D",
                },
              },
            }}
          />

          <Box mt={2}>
            <label
              style={{
                fontWeight: 500,
                marginBottom: "4px",
                display: "block",
              }}
            >
              {t("filters.dataModel.lastUpdate")}
            </label>
            <Box display="flex" justifyContent="space-between">
              <Box display="flex" flexDirection="column">
                <Typography
                  sx={{
                    color: "black",
                    whiteSpace: "nowrap",
                    marginTop: "2%",
                  }}
                >
                  {t("filters.dataModel.from")}
                </Typography>
                <TextField
                  fullWidth
                  type="date"
                  name="from"
                  value={filters.lastUpdate.from}
                  onChange={handleLastUpdateChange}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  variant="outlined"
                  sx={{
                    marginTop: 0,
                    marginBottom: "2%",
                    borderRadius: "6px",

                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "#2E404D",
                      },
                      "&:hover fieldset": {
                        borderColor: "rgba(0,91,176,0.75)",
                        boxShadow: "1px 0px 3px 0px rgba(0,91,176,0.75)",
                        webkitBoxShadow: "1px 0px 3px 0px rgba(0,91,176,0.75)",
                        mozBoxShadow: "1px 0px 3px 0px rgba(0,91,176,0.75)",
                      },
                      "&.Mui-focused fieldset": {
                        boxShadow: "0px 0px 0px 0px rgba(0,91,176,0.75)",
                        webkitBoxShadow: "0px 0px 0px 0px rgba(0,91,176,0.75)",
                        mozBoxShadow: "0px 0px 0px 0px rgba(0,91,176,0.75)",
                        borderColor: "#1976d2",
                      },
                    },

                    "& .MuiOutlinedInput-input": {
                      padding: "6px 12px",
                      "&::placeholder": {
                        color: "#2E404D",
                      },
                    },
                  }}
                />
              </Box>
              <Box display="flex" flexDirection="column">
                <Typography
                  sx={{
                    color: "black",
                    whiteSpace: "nowrap",
                    marginTop: "2%",
                  }}
                >
                  {t("filters.dataModel.to")}
                </Typography>
                <TextField
                  fullWidth
                  type="date"
                  name="to"
                  value={filters.lastUpdate.to}
                  onChange={handleLastUpdateChange}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  variant="outlined"
                  sx={{
                    marginTop: 0,
                    marginBottom: "2%",
                    borderRadius: "6px",

                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "#2E404D",
                      },
                      "&:hover fieldset": {
                        borderColor: "rgba(0,91,176,0.75)",
                        boxShadow: "1px 0px 3px 0px rgba(0,91,176,0.75)",
                        webkitBoxShadow: "1px 0px 3px 0px rgba(0,91,176,0.75)",
                        mozBoxShadow: "1px 0px 3px 0px rgba(0,91,176,0.75)",
                      },
                      "&.Mui-focused fieldset": {
                        boxShadow: "0px 0px 0px 0px rgba(0,91,176,0.75)",
                        webkitBoxShadow: "0px 0px 0px 0px rgba(0,91,176,0.75)",
                        mozBoxShadow: "0px 0px 0px 0px rgba(0,91,176,0.75)",
                        borderColor: "#1976d2",
                      },
                    },

                    "& .MuiOutlinedInput-input": {
                      padding: "6px 12px",
                      "&::placeholder": {
                        color: "#2E404D",
                      },
                    },
                  }}
                />
              </Box>
            </Box>
          </Box>
        </Box>

        {/* Sección de botones */}
        <Box mt={4} display="flex" flexDirection="column" gap={1}>
          <Button
            sx={{
              marginBottom: "4%",
              backgroundColor: "var(--main-color)",
              textTransform: "none",
              fontSize: "1rem",
              fontWeight: "400",
              lineHeight: "1.5",
            }}
            variant="contained"
            color="primary"
            onClick={handleApply}
          >
            {t("filters.dataModel.apply")}
          </Button>
          <Button
            sx={{
              marginBottom: "4%",
              backgroundColor: "#FFFFFF",
              borderColor: "var(--main-color)",
              textTransform: "none",
              fontSize: "1rem",
              fontWeight: "400",
              lineHeight: "1.5",
            }}
            variant="outlined"
            onClick={handleClear}
          >
            {t("filters.dataModel.clear")}
          </Button>
        </Box>
      </Box>
    </Drawer>
  );
};

export default FilterRightBox;
